import Vue from "vue";
import Scaleloader from "vue-spinner/src/BounceLoader.vue";
Vue.component("ring-loader", Scaleloader);
